import React, { useEffect, useState } from "react";
import { fetchClasses, deleteClass } from "../../actions/classActions";
import { Button, Row, Col, Input, Table } from "reactstrap";
import CreateClassWithManyTeachersModal from "../../components/Modal/CreateClassWithManyTeachersModal";
import { PacmanLoader } from "react-spinners";
import ConfirmDialog from "../../components/Modal/ConfirmDialog";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fetchProgrammes } from "../../actions/programmeActions";
import { fetchOrientations } from "../../actions/orientationActions";
import UpdateClassModal from "../../components/Modal/UpdateClassModal";
import { useSelector, useDispatch } from "react-redux";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";

function Classes(props) {
  const [school] = useState(
    props.location.state
      ? props.location.state.school
      : JSON.parse(localStorage.getItem("school"))
  );
  const [createClassModal, setCreateClassModal] = useState(false);
  const [updateClassModal, setUpdateClassModal] = useState(false);
  const [overrideLoader, setOverrideLoader] = useState(false);
  const [classes, setClasses] = useState([]);
  const [classToRemove, setClassToRemove] = useState(null);
  const [classToUpdate, setClassToUpdate] = useState(null);
  const [displayConfirmDialog, setDisplayConfirmDialog] = useState(false);

  const dispatch = useDispatch();
  const classReducer = useSelector((state) => state.classReducer);
  const programmes = useSelector((state) => state.programmeReducer);
  const orientations = useSelector((state) => state.orientationReducer);

  useEffect(() => {
    dispatch(fetchClasses(school.id));
    dispatch(fetchProgrammes(school.id));
    dispatch(fetchOrientations(school.id));
  }, [school, dispatch]);

  useEffect(() => {
    if (!classReducer.loading)
      localStorage.setItem("school", JSON.stringify(school));
    setClasses(classReducer.result);
  }, [school, classReducer]);

  const loadClasses = () => {
    setOverrideLoader(true);
    dispatch(fetchClasses(school.id)).then(() => {
      setClasses(classReducer.result);
    });
  };

  const toggleClassModal = () => {
    setCreateClassModal(!createClassModal);
  };

  const toggleUpdateClassModal = () => {
    setUpdateClassModal(!updateClassModal);
  };

  const getDataAfterUpdate = () => {
    dispatch(fetchOrientations(school.id));
    loadClasses();
  };

  const toggleConfirmDialog = (id) => {
    setClassToRemove(id);
    setDisplayConfirmDialog(!displayConfirmDialog);
  };

  const handleDeleteClass = () => {
    setOverrideLoader(true);
    dispatch(deleteClass(classToRemove.id))
      .then(() => {
        loadClasses();
        toast.success(
          <FormattedMessage id="Views.Admin.DeleteClassFromSchool.Success" />,
          TOAST_CONFIG
        );
      })
      .catch((err) => {
        toast.error(err.response.data, TOAST_CONFIG);
      });
    setClassToRemove(null);
    setDisplayConfirmDialog(false);
  };

  const getAllTeachers = () => {
    var teachers = [];
    if (classes.length) {
      classes.forEach((c) => {
        c.teachers.forEach((t) => {
          if (
            teachers.filter(function (e) {
              return e.id === t.id;
            }).length < 1
          ) {
            teachers.push(t);
          }
        });
      });
    }
    return teachers;
  };

  const getAllStudents = () => {
    var students = [];
    classes.forEach((c) => {
      c.students.forEach((s) => {
        if (
          students.filter(function (e) {
            return e.id === s.id;
          }).length < 1
        ) {
          students.push(s);
        }
      });
    });
    return students;
  };

  const getClassToRemove = () => {
    if (classToRemove) {
      let c = classes.find((c) => c.id === classToRemove.id);
      if (c) return c.name;
    }
    return "Okänd";
  };

  const handleFilterSearch = (event) => {
    setClasses(
      classReducer.result.filter((c) => {
        if (c.name.toLowerCase().indexOf(event.target.value) !== -1) {
          return c;
        }
        return null;
      })
    );
  };

  if (classReducer.loading && overrideLoader === false) {
    return (
      <div
        className="sweet-loading"
        style={{ position: "fixed", top: "50%", left: "50%" }}
      >
        <PacmanLoader color={"#20a8d8"} loading={true} />
      </div>
    );
  }

  const mappedClasses = () => {
    if (classes.length) {
      return classes.map((c, id) => {
        return (
          <tr
            key={id}
            onClick={() =>
              props.history.push({
                pathname: "/superuser/schools/classes/classoverview",
                state: {
                  schoolId: school.id,
                  teachers: getAllTeachers(),
                  students: getAllStudents(),
                  class: c,
                  schoolClasses: classes,
                },
              })
            }
          >
            <td>{c.name}</td>
            <td>{c.programme.name}</td>
            <td>{c.orientation ? c.orientation.name : "Ospecificerad"}</td>
            <td>{c.students.length}</td>
            <td>{c.teachers.length}</td>
            <td>
              <Button
                onClick={(e) => {
                  setClassToUpdate(c);
                  toggleUpdateClassModal();
                  e.stopPropagation();
                }}
                size="sm"
                color="primary"
                outline
                className="me-1"
              >
                <FontAwesomeIcon icon="edit" />
              </Button>
              <Button
                onClick={(e) => {
                  setClassToRemove(c);
                  setDisplayConfirmDialog(true);
                  e.stopPropagation();
                }}
                size="sm"
                color="danger"
                outline
              >
                <FontAwesomeIcon icon="trash" />
              </Button>
            </td>
          </tr>
        );
      });
    }
  };
  return (
    <div>
      <div className="card card-body">
        <h5 className="no-margin">Klasser {school.name}</h5>
      </div>
      <div className="container-fluid admin-container w-75">
        <Row>
          <Col className="col-12">
            <Row className="search-row">
              <Col className="col-4">
                <Input
                  className="search-input"
                  placeholder="Sök klass"
                  onChange={(data) => handleFilterSearch(data)}
                />
              </Col>
              <Col className="offset-6 col-2">
                <Button
                  color="primary"
                  outline
                  className="float-end"
                  onClick={() => {
                    toggleClassModal();
                  }}
                >
                  <FontAwesomeIcon icon="plus" />
                </Button>
              </Col>
            </Row>
            <Table hover className="school-table clickable">
              <thead>
                <tr>
                  <th>Namn</th>
                  <th>Program</th>
                  <th>Inriktning</th>
                  <th>Antal elever</th>
                  <th>Antal lärare</th>
                  <th />
                </tr>
              </thead>
              <tbody>{mappedClasses()}</tbody>
            </Table>
          </Col>
        </Row>
      </div>

      <ConfirmDialog
        isOpen={displayConfirmDialog}
        title="Ta bort klass"
        message={
          <div>
            <p>
              Är du säker på att du vill ta bort klassen '
              <strong>{getClassToRemove()}</strong>'?
            </p>
            <p>
              <em>Det här valet går inte att ångra.</em>
            </p>
          </div>
        }
        toggle={toggleConfirmDialog}
        onProceed={handleDeleteClass}
        danger={true}
      />

      <CreateClassWithManyTeachersModal
        isOpen={createClassModal}
        toggle={toggleClassModal}
        multipleTeachers={true}
        teachers={getAllTeachers()}
        programmes={programmes.result}
        reloadClasses={loadClasses}
        school={school}
        dismissModal={toggleClassModal.bind(this)}
        orientations={orientations.result}
      />

      <UpdateClassModal
        isOpen={updateClassModal}
        toggle={toggleUpdateClassModal}
        classToUpdate={classToUpdate}
        dismissModal={toggleUpdateClassModal.bind(this)}
        programmeSelection={programmes.result}
        teacherSelection={getAllTeachers()}
        orientationSelection={orientations.result}
        onProceed={getDataAfterUpdate}
      />
    </div>
  );
}

export default Classes;
